export function formatPrice(value) {
    if (isNaN(Number(value)))
        return "";
    const formatOptions = {
        minimumFractionDigits: 2,
        useGrouping: false,
    };
    return new Intl.NumberFormat("en", formatOptions).format(Number(value));
}
export function formatPriceFromCents(cents) {
    return formatPrice(Number(cents) / 100);
}
export function humanizePrice(value, options) {
    if (isNaN(Number(value)))
        return "";
    const formatOptions = {
        style: options?.hideCurrencySymbol ? "decimal" : "currency",
        currency: options?.currency || "EUR",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    };
    const price = new Intl.NumberFormat(options?.locale || "de-DE", formatOptions).format(Number(value));
    return options?.hideTrailingZeros ? price.replace(",00", "") : price;
}
export function humanizePriceFromCents(cents, options) {
    return humanizePrice(Number(cents) / 100, options);
}
export function getPrice(prices, type, paymentFrequency) {
    if (!prices)
        return undefined;
    return prices.find((price) => price &&
        price.type === type &&
        price.paymentFrequency === paymentFrequency);
}
export const defaultPriceOptions = {
    hideCurrencySymbol: false,
    hideTrailingZeros: true,
};
export function getPriceFormatted(prices, type, paymentFrequency, options = defaultPriceOptions) {
    const price = getPrice(prices, type, paymentFrequency);
    return price?.amount
        ? humanizePriceFromCents(price.amount, options)
        : undefined;
}
